<template>
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Member Attendance</h2>
            <a   class="btn b-solid btn-sm btn-primary-solid"   @click="syncAttendance()">Sync Attendance</a>
        </div>
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4" style="overflow:scroll">
                        <table id="basicDataTable" class="datatable">
                                    <thead>
                                        <tr>
                                            <th>Sr.No</th>
                                            <th>Member Name</th>
                                            <th v-for="(day, index) in AllDays" :key="index">{{ day }}</th>
                                            <th>Total Presenty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in attendanceReport" :key="index">
                                            <td>{{ index + 1 }}</td>
                                            <td v-for="(data, dataIndex) in item" :key="dataIndex">
                                                <div v-if="data != 'A' && data != 'P'">{{ data }}</div>
                                                <div v-else-if="data != 'A'" class=" ">✓</div>
                                                <div v-else></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                   </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div> 
</template>

<style scoped>
.present {
    background: green !important;
}
td{
    text-transform: capitalize;
}
</style>

<script>
 
import ModalsPart from '@/components/Modals.vue';
import axios from 'axios';

export default {
    name: 'attendanceReport',
    components: { 
        ModalsPart,
    },
    data() {
        return {
            AllDays: [],
            attendanceReport: [],
            monthYearOptions: [],
            selectedMonthYear: '',
        };
    },
    computed: {
        daysInMonth() {
            const [month, year] = this.selectedMonthYear.split('-').map(Number);
            return new Date(year, month, 0).getDate();
        },
    },
    mounted() {
        this.generateMonthYearOptions();
        this.getBasics();
    },
    methods: {
        // generateMonthYearOptions() {
        //     const currentYear = new Date().getFullYear();
        //     const currentMonth = new Date().getMonth() + 1;

        //     for (let year = currentYear; year >= currentYear - 10; year--) {
        //         for (let month = 12; month >= 1; month--) {
        //             const monthLabel = new Date(year, month - 1).toLocaleString('default', { month: 'long' });
        //             this.monthYearOptions.push({
        //                 label: `${monthLabel} ${year}`,
        //                 value: `${month}-${year}`,
        //             });
        //         }
        //     }

        //     this.selectedMonthYear = `${currentMonth}-${currentYear}`;
        // },
        generateMonthYearOptions() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    for (let year = currentYear; year >= currentYear - 10; year--) {
        for (let month = 12; month >= 1; month--) {
            // Skip adding months after the current month and year
            if (year > currentYear || (year === currentYear && month > currentMonth)) {
                continue;
            }

            const monthLabel = new Date(year, month - 1).toLocaleString('default', { month: 'long' });
            this.monthYearOptions.push({
                label: `${monthLabel} ${year}`,
                value: `${month}-${year}`,
            });
        }
    }

    this.selectedMonthYear = `${currentMonth}-${currentYear}`;
}
,
        getBasics() {
            
            const [month, year] = this.selectedMonthYear.split('-').map(Number);

            this.AllDays = Array.from({ length: this.daysInMonth }, (v, i) => i + 1);

            axios.post('getAttendanceReport', {
                month: month,
                year: year,
            }).then(response => {
                this.attendanceReport = response.data.attendanceReport;
                window.scrollTo(0, 0);
            });
            // .then(() => {
            //     if ($.fn.dataTable.isDataTable('.datatable')) {
            //         $('.datatable').DataTable().destroy();
            //     }
            //     $(".datatable").DataTable({
            //         dom: 'Bfrtip',
            //         buttons: ['excel', 'print'],
            //         paging: true,
            //         ordering: true,
            //         autoWidth: false,
            //     });
            // });
        },
    
    
    
     syncAttendance() {
            
            const [month, year] = this.selectedMonthYear.split('-').map(Number);

            this.AllDays = Array.from({ length: this.daysInMonth }, (v, i) => i + 1);

            axios.post('syncAttendance', {
                month: month,
                year: year,
            }).then(response => {
                this.attendanceReport = response.data.attendanceReport;
                window.scrollTo(0, 0);
            }); 
        },
    },
        
        
};
</script>
